<template lang="pug">

	b-modal(centered :id="_id" title="Подтверждение")
		p.my-4 Вы хотите принять участие в мероприятии «{{_event.title}}»?

		Alerts(ref="Alerts")

		div.text-success.mb-2(v-if="isSend")
			strong Вы будете перенаправлены на страницу участия через {{ okCountDown }} сек

		template(slot="modal-footer")
			.g-between-center.w-100
				b-button(variant="danger" :disabled="isSend" @click="$bvModal.hide(_id)") Отмена
				b-button(variant="success" :disabled="isSend" @click="createParticipant" type="submit") Зарегистрироваться

</template>
<script>
	import { mapState,mapActions } from 'vuex'

	import router from "@/router";
	import Alerts from '../Alerts'
	import modelPpnt from '../../../store/models/modelPpnt'


	export default {
		name: 'eventsExtraDataModal',
		props: {
			_event: Object,
			_id: String,
		},
		components: {
			Alerts
		},
		data: () => ({
			isSend: false,
			okCountDown: 5,
			modelPpnt,
			modalDelay: 5000,
		}),
		computed: {
			...mapState(['myParticipants', 'events', 'account']),
		},
		methods: {
			...mapActions(['updateOneEvent']),
			createParticipant(){
				this.$store.dispatch('postMyParticipant', { ...modelPpnt, event:this._event.id, user:this.account.data.id})
					.then(this.cbOK)
			},
			cbOK(response){
				const createdPpnt = response.data;

				this.$store.dispatch('updateOneEvent',{id:this._event.id,data: {is_participant:createdPpnt.id}});

				this.$refs.Alerts.showAlert(this.okMsg, 'success');
				this.isSend = true;

				let interval = setInterval(()=>{
					this.okCountDown>0
						? this.okCountDown--
						: clearInterval(interval);
				},1000);

				setTimeout(()=>{
					this.isSend = false;
					this.okCountDown = 5;
					router.push({ path: `/registrations/${createdPpnt.id}/#just-created`});
				}, this.modalDelay);
			},
		},
	}
</script>

<style scoped></style>
